module.exports = __webpack_public_path__ + "img/dragon tiger icon 2.a4b1b499.png";